import { combineReducers } from "redux";
import { LoginReduser } from "./loginReducer";
import UserReduser from "./userReduser";

const rootReduser = combineReducers({ User: UserReduser, Login: LoginReduser });

export default rootReduser;
